import React, { useState, useEffect } from "react";
import { Button, DropdownItem } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/js/src/collapse.js";


import { appName, appLogo } from "../config/appConfig";
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLanguage, faSignOut } from "@fortawesome/free-solid-svg-icons";

import { navbarMenuOptions } from "../config/appConfig";

import { appBaseUrl } from "../config/appConfig";
import { DropdownButton } from "react-bootstrap";
import Dropdown from 'react-bootstrap/Dropdown';


import i18n from "../i18n";
import i18next from 'i18next'

const Header = ({ onSuccess }) => {
  const [activeObject, setActiveObject] = useState({
    home: "active",
    dashboard: "",
    linelist: "",
    alerts: "",
    pathway: "",
    qrcode: "",
    adherance: "",
  });

  const userObject = JSON.parse(sessionStorage.getItem("userData"))
  const adminFlag = userObject.username == "cdicsuperadmin" ? true : false
  const navigate = useNavigate();
  console.log(userObject,adminFlag,"userObject")
  useEffect(() => {
    // if(adminFlag)
      if(JSON.parse(sessionStorage.getItem("userData")).username == "cdicsuperadmin"){
        let activeStateHolder = {
          home: "",
          dashboard: "",
          linelist: "",
          alerts: "",
          pathway: "",
          qrcode: "",
          adherance: "",
          datamanagement:"active"
        }
        let currentPath = window.location.pathname.split('/').pop()
        // activeStateHolder[currentPath] = "active"
        setActiveObject(activeStateHolder)
        navigate("/datamanagement");
      }

    //Runs on every render
  },[]);


  const setActiveTab = () => {
    let activeStateHolder = {
      home: "",
      dashboard: "",
      linelist: "",
      alerts: "",
      pathway: "",
      qrcode: "",
      adherance: "",
    }
    let currentPath = window.location.pathname.split('/').pop()
    activeStateHolder[currentPath] = "active"
    setActiveObject(activeStateHolder)
  }


  const handleLogout = () => {
    // console.log(":inside logout");
    sessionStorage.clear()
    sessionStorage.clear()
    onSuccess()
    navigate("/");
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  }

  return (
    <>
      <Navbar bg="light" className="login_navbar" expand="lg">
        {/* <Container> */}
        <Navbar.Collapse href="#">
          {/* <img src={appLogo} className="logoCss" alt="logo" /> */}
          <h4 className="navTitle mr-3" style={{color:'#fff'}} >CDIC</h4>
          {/* <h4 className="p-1" style={{ color : '#a51c30c' }} >{sessionStorage.getItem("userData") ? JSON.parse(sessionStorage.getItem("userData")).appname : ""}</h4> */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav mr-auto">
              {!adminFlag ? <>
                <li onClick={() => setActiveTab()} className={`nav-item ${activeObject.home}`}>
                <Link
                  to="home"
                  className="nav-link"
                >
                  Home
                </Link>
              </li>
              <li onClick={() => setActiveTab()} className={`nav-item ${activeObject.pathway}`}>
                <Link
                  to="pathway"
                  className="nav-link"
                >
                  Pathway
                </Link>
              </li>
              {/* <li onClick={() => setActiveTab()} className={`nav-item ${activeObject.adherencecalendar}`}>
                <Link
                  to="adherencecalendar"
                  className="nav-link"
                >
                  Treatment Adherence Review
                </Link>
              </li> */}
              <li onClick={() => setActiveTab()} className={`nav-item ${activeObject.linelist}`}>
                <Link
                  to="linelist"
                  className="nav-link"
                // onClick={() => this.clearIndicator()}
                >
                  Line list
                </Link>
              </li>
              <li onClick={() => setActiveTab()} className={`nav-item ${activeObject.alerts}`}>
                <Link
                  to="alerts"
                  className="nav-link"
                // onClick={() => this.clearIndicator()}
                >
                  Alerts
                </Link>
              </li>
              </> : <></>}

              {adminFlag ? <>
                <li onClick={() => setActiveTab()} className={`nav-item ${activeObject.datamanagement}`}>
                <Link
                  to="datamanagement"
                  className="nav-link"
                >
                  Data Management
                </Link>
              </li>
                <li onClick={() => setActiveTab()} className={`nav-item ${activeObject.upload}`}>
                <Link
                  to="upload"
                  className="nav-link"
                // onClick={() => this.clearIndicator()}
                >
                  Data Upload
                </Link>
              </li>
              <li onClick={() => setActiveTab()} className={`nav-item ${activeObject.uploadlogs}`}>
                <Link
                  to="uploadlogs"
                  className="nav-link"
                // onClick={() => this.clearIndicator()}
                >
                  Data Upload Logs
                </Link>
              </li>
              <li onClick={() => setActiveTab()} className={`nav-item ${activeObject.usermanagement}`}>
                <Link
                  to="usermanagement"
                  className="nav-link"
                // onClick={() => this.clearIndicator()}
                >
                  User Management
                </Link>
              </li>
              <li onClick={() => setActiveTab()} className={`nav-item ${activeObject.facilitymanagement}`}>
                <Link
                  to="facilitymanagement"
                  className="nav-link"
                // onClick={() => this.clearIndicator()}
                >
                  Facility Management
                </Link>
              </li>
              </> : <></>}
              
              
              {/* <li onClick={() => setActiveTab()} className={`nav-item ${activeObject.qrcode}`}>
                <Link
                  to="qrcode"
                  className="nav-link"
                >
                  QR Code Generation
                </Link>
              </li> */}
              <>
                {/* <li className={`nav-item`}>
                    <a
                      className="nav-link"
                      href="/smartsetup/"
                      //onClick={() => this.menuActive("linelist")}
                      target="_blank"
                    >
                      Smart Setup
                    </a>
                  </li> */}
                {/* <li className={`nav-item`}>
                    <a
                      className="nav-link"
                      href="/indexupload/"
                      //onClick={() => this.menuActive("linelist")}
                      target="_blank"
                    >
                      Index Upload
                    </a>
                  </li> */}

              </>
            </ul>
          </div>
          <div className="d-flex">
            <Dropdown className="langSelector">
              <Dropdown.Toggle variant="outline-light logout" id="dropdown-basic">
              <FontAwesomeIcon icon={faLanguage} />
              </Dropdown.Toggle>

              <Dropdown.Menu >
                <Dropdown.Item onClick={(e) => changeLanguage('en')} value="en">English</Dropdown.Item>
                <Dropdown.Item onClick={(e) => changeLanguage('tg')} value="tg">Tajik</Dropdown.Item>
                <Dropdown.Item onClick={(e) => changeLanguage('ru')} value="ru">Russian</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            <Button
              outline
              color="light"
              className="logout d-flex"
              onClick={() => handleLogout()}
              style={{ "alignItems": "center" }}
            >
              {" "}
              {/* <Link to="/"> */}
              <span>Logout</span>
              <FontAwesomeIcon className="p-2 m-auto logout btn-outline-light " icon={faSignOut} />
              {/* </Link> */}
            </Button>
          </div>

        </Navbar.Collapse>
        {/* </Container> */}
      </Navbar>
    </>
  );
}

export default Header;
